import React, { HTMLAttributes } from 'react'
import { withIdentity, WithIdentityProps } from '#src/containers/Identity'
import StandardFooter from './StandardFooter'
import MarketingFooter from './MarketingFooter'

export interface FooterProps extends HTMLAttributes<HTMLDivElement>, WithIdentityProps {
  isDepartmentSpecificPage?: boolean
  sidebar?: boolean
  hideWidget?: boolean
}

const Footer: React.SFC<FooterProps> = ({ isDepartmentSpecificPage = true, myself, ...props }) => {
  // Only show the "marketing" footer if:
  //  - The page isn't department specific (for example: "How it works", "About Curated", "FAQs")
  //  - The user is logged out
  if (!isDepartmentSpecificPage && !myself) {
    return <MarketingFooter {...props} />
  } else {
    return <StandardFooter {...props} />
  }
}

export default withIdentity(Footer)
